module.exports = __webpack_public_path__ + "dcc7eeff893226a811e362ce63ba8dd3.svg";